import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_TABLE_SUCCESS,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_DATES,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  UPDATE_FILTERS
} from "./lifetimeValueByMembershipsSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  currencySymbol: "",
  isLoading: true,
  initialRequest: false,
  updatesLoading: false,
  filtersDirty: false,
  table: {},
  filters: {
    members_view: [],
    membership_types: []
  },
  selectedFilters: {
    members_view: { id: "all_time_members", name: "All Time Members" }
  },
  rangeOptions: [],
  selectedRangeOption: {}
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      const allTimeOption = rangeOptions.find((elem) =>
        elem.name.includes("All Time (Historical)")
      );
      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: rangeOptions,
        selectedRangeOption: allTimeOption
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      currencySymbol: action.payload.currencySymbol,
      initialRequest: true
    }),
    [FETCH_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      table: action.payload
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: { ...action.payload },
      selectedFilters: {
        ...initialState.selectedFilters,
        membership_types: action.payload.membership_types
      }
    }),
    [UPDATE_FILTERS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, ...payload }
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    })
  },

  initialState
);
